/**
 * True when pathname is an in-arena live session (`/room/:code/session`).
 * Waiting lobby `/room/:code` stays on normal platform chrome.
 */
export function isArenaSessionPath(pathname) {
  if (!pathname || typeof pathname !== "string") return false;
  return /^\/room\/[^/]+\/session\/?$/.test(pathname);
}
